import {
  NumberFormat,
  SelectField,
  StandardDialog,
  SubmitDialog,
  TextField,
} from '@roc/ui';
import {
  DrawRequestShared,
  DrawSuccess,
  useDrawsStore,
} from '@roc/feature-draws';
import { observer } from 'mobx-react';
import { Grid, Typography } from '@material-ui/core';
import { isNotBlank } from '@roc/feature-utils';
import { useLoanStore } from '@roc/feature-loans';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Button, Paper } from '@roc/ui';

const useStyles = makeStyles(theme => ({
  paper: {
    margin: 24,
  },
  container: {
    padding: 32,
  },
  dealName: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

export const drawTypes = [
  {
    label: 'Soft Cost',
    value: 'soft costs',
  },
  {
    label: 'Hard Cost',
    value: 'hard costs',
  },
  {
    label: 'Hard Cost & Soft Cost',
    value: 'hard & soft costs',
  },
  {
    label: 'Insurance Draw',
    value: 'insurance',
  },
];

export const AddDrawV2 = observer(({ loanId }) => {
  const { loanStore } = useLoanStore();
  const classes = useStyles();
  const [showSuccessScreen, setShowSuccessScreen] = useState(false);
  const { drawRequestStore } = useDrawsStore();
  const { drawStore } = useDrawsStore();
  const { loanDetails } = loanStore;
  const { drawActionsStore, addDrawFormStore } = drawStore;
  const { pointOfContactFormStore } = drawRequestStore.pointOfContactStore;

  const initialize = async lenderId => {
    drawRequestStore.reset();
    drawRequestStore.pointOfContactStore.resetStore();
    await drawRequestStore.pointOfContactStore.fetchLenderInfo(lenderId);
    drawRequestStore.pointOfContactStore.setForm();
  };

  useEffect(() => {
    if (drawActionsStore.isAddDrawDialogOpen && loanDetails) {
      initialize(loanDetails.lenderId);
    }
  }, [drawActionsStore.isAddDrawDialogOpen, loanDetails]);

  const submit = async () => {
    drawRequestStore.successLoad = false;

    pointOfContactFormStore.runFormValidationWithMessage();
    if (pointOfContactFormStore.form.meta.isValid) {
      await drawRequestStore.submitRequest();
      addDrawFormStore.reset();
      drawStore.fetchDraws(loanId, true);
      drawActionsStore.setIsAddDrawDialogOpen(false);
    }
  };

  const dialogActions = (
    <>
      <Button
        style={{ marginRight: '8px' }}
        testId="print-pdf"
        color="default"
        variant="outlined"
        onClick={() => drawActionsStore.setIsAddDrawDialogOpen(false)}
      >
        Cancel
      </Button>
      <Button
        testId="download-pdf"
        color="primary"
        variant="contained"
        onClick={submit}
      >
        Start Draw Request
      </Button>
    </>
  );

  return (
    <StandardDialog
      title="Request Draw"
      maxWidth="md"
      open={drawActionsStore.isAddDrawDialogOpen}
      handleClose={() => drawActionsStore.setIsAddDrawDialogOpen(false)}
      dialogActions={dialogActions}
      dialogContent={
        <>
          {showSuccessScreen ? (
            <Paper className={classes.paper}>
              <DrawSuccess />;
            </Paper>
          ) : (
            <DrawRequestShared
              showStartDrawRequestButton={false}
              showInsuranceType={true}
              setShowSuccessScreen={setShowSuccessScreen}
            />
          )}
        </>
      }
    />
  );
});
